import React from "react"
import EngineIDNavBar from "@components/EngineIDNavBar"
import Banner from "./Banner"
import SectionOne from "./SectionOne"
import SectionTwo from "./SectionTwo"
import WeBelieve from "./WeBelieve"
import CTAMessage from "@components/CTAMessage"
import CTASignUpLong from "@components/CTASignUpLong"
import Footer from "@components/Footer"
import "./index.scss"
import "@styles/global.scss"

const FeaturePage = props => {
  return (
    <div>
      <EngineIDNavBar />
      <Banner />
      <div className={"container-fluid"}>
        <div className={"maxWidth"}>
          <SectionOne></SectionOne>
          <CTAMessage 
            textMessage="The App Launch Dashboard and many more features are available at your fingertips with EngineID."
            textMessageBold="Register your organization on our free plan and get up and running in minutes!"></CTAMessage>
          <SectionTwo></SectionTwo>
          <WeBelieve></WeBelieve>
        </div>
      </div>
      <CTASignUpLong />
      <Footer />
    </div>
  )
}

export default FeaturePage
